import { render, staticRenderFns } from "./ContentManagement.vue?vue&type=template&id=47391222&scoped=true&"
import script from "./ContentManagement.vue?vue&type=script&lang=js&"
export * from "./ContentManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47391222",
  null
  
)

export default component.exports